import shop from "@/api/poolFormulas";

// initial state
const state = {
    all: [],
    Formula: {}
};

// getters
const getters = {
    formula: state => {
        return state.poolFormula;
    },
    formulas: state => {
        return state.all;
    }
};

// actions
const actions = {
    getAllFormulas({
        commit
    }) {
        shop.getFormulas().then(Formulas => {
            commit("getFormulas", Formulas.data);
        });
    },
    searchFormula: async (context, Formula) => {
        let d = (await shop.searchFormulas(Formula)).data;
        context.commit("getFormulas", d);
        return d;
    },
    getFormula: async (context, id) => {
        let d = (await shop.getFormula(id)).data;
        context.commit("getFormula", d);
        return d;
    },
    postFormula: async (context, Formula) => {
        const result = (await shop.postFormula(Formula)).data;
        context.commit("postFormula", result);
    },
    putFormula: async (context, Formula) => {
        const result = (await shop.putFormula(Formula)).data;
        context.commit("putFormula", result);
    },
    deleteFormula: async (context, Formula) => {
       (await shop.deleteFormula(Formula)).data;
        context.commit("deleteFormula", Formula);
    }

};

// mutations
const mutations = {
    getFormulas(state, Formulas) {
        state.all = Formulas;
    },
    getFormula(state, Formula) {
        //state.Formula = Formula
        state.Formula=null;
        state.Formula = Object.assign({}, state.Formula, Formula);
    },
    postFormula(state, Formula) {
        //state.Formula = Formula
        state.Formula=null;
        state.Formula = Object.assign({}, state.Formula, Formula);
    },
    putFormula(state, Formula) {
        //state.Formula = Formula
        state.Formula=null;
        state.Formula = Object.assign({}, state.Formula, Formula);
    },
    deleteFormula(state, Formula) {
        state.all.splice(state.all.indexOf(Formula), 1);
    },
    decrementFormulaInventory(state, {
        id
    }) {
        const Formula = state.all.find(Formula => Formula.id === id);
        Formula.inventory--;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};